import { surveys as schemaSurveys } from './schemas';
import apiClient from './apiClient';
import GetSurveysDataStore from '../../datastores/GetSurveysDataStore';

class SurveysValidationDataStoreGraphQL implements GetSurveysDataStore {
  async getSurveysValidation() {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaSurveys.getSurveysValidation
      });
      return response.data?.externalSettings?.surveyConfig;
    } catch (error) {
      throw new Error('error getSurveysValidation');
    }
  }
}

export default SurveysValidationDataStoreGraphQL;
